<script>
import {
  computed,
  defineComponent,
  onBeforeMount, ref,
} from "vue";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";
import Skeleton from "primevue/skeleton"
import { useApiCall } from "@/composables/useApiCall";
import {
  hintsApiCall
} from "@/services/settings"
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default defineComponent({
  layout: { name: 'AdminLayout' },
  components: {
    Column,
    DataTable,
    Skeleton,
  },
  setup() {
    const {t} = useI18n()
    const store = useStore();
    const isLoading = ref(true)
    const lang = computed(() => store.getters.getLang);
    const tableData = ref([
      {
        title: 'Общая сумма доходов по всем объектам в управлении УК',
        key: 'total_income'
      },
      {
        title: 'Общая сумма удержаний по всем объектам в управлении УК',
        key: 'total_deduction'
      },
      {
        title: 'Общая сумма расходов по всем объектам',
        key: 'total_expense'
      },
      {
        title: 'Общая сумма дохода к выплате по всем объектам',
        key: 'total_to_pay'
      }
    ])
    const {
      data: hintsData,
      executeApiCall: getHintsAction,
    } = useApiCall(hintsApiCall, true)

    onBeforeMount(async () => {
      await getHintsAction()
      if (hintsData.value) {
        tableData.value.forEach((item) => {
          for (const key in hintsData.value.data) {
            if (key.includes(item.key) && !item[key]) {
              item[key] = hintsData.value.data[key]
            }
          }
        })
      }
      isLoading.value = false
    })

    return {
      t,
      isLoading,
      tableData,
      lang,
    };
  },
})
</script>

<template>
      <div class="settings__modals">
        <DataTable :value="tableData ? tableData : []" :loading="isLoading" showGridlines tableStyle="min-width: 50rem" selectionMode="single">
          <Column field="first_name" header="Название графика" style="width: 50%">
            <template #body="slotProps">
              <router-link
                  :to="{name: 'hints-item', params: {key: slotProps.data.key}}"
                  class="flex flex-column gap-3 settings__modals-item-link"
              >
                {{slotProps.data.title}}
              </router-link>
            </template>
          </Column>
          <Column field="segments" header="Описание" style="width: 50%">
            <template #body="slotProps">
              <span class="settings__modals-item-segment">{{slotProps.data[`${slotProps.data.key}_${lang}`]}}</span>
            </template>
          </Column>
          <template #empty>Пояснения отсутствуют</template>
        </DataTable>
      </div>
</template>
<style lang="scss" scoped>
::v-deep(.p-column-header-content) {
  font-family: "RF Dewi", sans-serif;
  justify-content: start !important;
}
::v-deep(.p-column-title) {
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  text-align: start;
  padding-left: 4px;
}
.settings {
  &__title {
    min-height: 37px;
  }
  &__link {
    text-decoration: unset;
  }
  &__modals {
    background: white;
    &-item {
      display: grid;
      grid-template-columns: 1fr 1fr 114px;
      &-link {
        font-weight: 400;
        font-size: 18px;
        line-height: 100%;
        text-decoration: underline;
        color: #C3987A;
        text-align: left;
        padding-left: 4px;
      }
      &-segment {
        padding-left: 4px;
        display: flex;
        font-weight: 400;
        font-size: 18px;
        line-height: 100%;
        color: #333333;
        text-align: left;
      }
      &-delete {
        background: unset;
        border: none;
        cursor: pointer;
      }
    }
    &-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 300px;
      width: 100%;
      color: var(--color-black-40);
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }
  }

}
::v-deep(.p-menuitem-text) {
  white-space: nowrap;
}
::v-deep(.p-tabmenu .p-tabmenu-nav) {
  border-color: transparent;
  gap: 24px;
}
::v-deep(.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link) {
  border-color: transparent;
  padding: 9px 0;
}
::v-deep(.p-menuitem-link) {
  box-shadow: unset !important;
}
::v-deep(.p-component-overlay) {
  background-color: rgba(255, 255, 255, 0.6);
}
::v-deep(.p-datatable-loading-icon) {
  path {
    fill: var(--color-primary);
  }
}
</style>